import React, { Component, Fragment } from "react";
import { Tabs, Card } from "antd";
import "antd/dist/antd.css";
import TournamentCard from "./tournamentcard";
const TabPane = Tabs.TabPane;
export default class TournamentList extends Component {
  callback(key) {
    console.log(key);
  }
  render() {
    return (
      <Fragment>
        <Card
          className="wow"
          title="Tournaments"
          headStyle={{ textAlign: "right" }}
        >
          <Tabs
            defaultActiveKey="1"
            onChange={this.callback}
            type="card"
            tabBarStyle={{
              textAlign: "left",
              border: "transparent",
               backgroundColor: "#1e2341", 
            }}
            style={{ color: "white" }}
          >
            <TabPane tab="ACTIVE TOURNAMENT" key="1">
              <div className="row">
                <div className="col-xs-6 ">
                  <TournamentCard /> <TournamentCard />
                </div>
                <div className="col-xs-6 ">
                  <TournamentCard /> <TournamentCard />
                </div>
              </div>
              <div class="showing">
                SHOWING 3 TOURNAMENTS OUT OF 347. <a className="underlineP" href="#">VIEW ALL</a>
              </div>
            </TabPane>
            <TabPane tab="UPCOMING TOURNAMENT" key="2">
              Content of Tab Pane 2
            </TabPane>
          </Tabs>
        </Card>
      </Fragment>
    );
  }
}
